import {handleEmailSending} from "../../helpers/email/emailHelper.ts";
import {fromCharCode} from "@opay/lib-core-js";

const OpayComplianceContactEmail = () => {

    const name = fromCharCode(99, 111, 109, 112, 108, 105, 97, 110, 99, 101);
    const domain = fromCharCode(111, 112, 97, 121, 46, 101, 117);

    return (
        <>
            <a className="contact-by-email" href='#' onClick={(e) => handleEmailSending(e, name, domain)}>
                {`${fromCharCode(99, 111, 109, 112, 108, 105, 97, 110, 99, 101, 64, 111, 112, 97, 121, 46, 101, 117)}`}
            </a>
        </>
    )
}

export default OpayComplianceContactEmail;
